import TemplateView from "../../TemplateView"
import Checkbox from "./Checkbox"
import {COLORS} from '../../workflowStatus/constants'
import {getColorClassById} from '../../workflowStatus/utils'

export default class SelectColorContent extends TemplateView {
    constructor({
                    onSelectColorCb = () => {}
                }) {
        super(null)

        this.params = {
            colorItems: Object.values(COLORS)
        }

        this.state = {
            selectedColorId: -1,
        }

        this.checkboxes = {}

        this.callbacks = {
            onSelectColorCb
        }

        this.onStatePropertyChanged('selectedColorId', () => {
            this._updateCheckboxes()
        })
    }

    templateHtml() {
        return '<div class="selectColorContainer"/>'
    }

    afterRender() {
        this.checkboxes = {}
        this.params.colorItems.forEach((id) => {
            this.checkboxes[id] = new Checkbox({
                boxClasses: getColorClassById(id),
                onClickCb: () => {
                    this.setState({
                        selectedColorId: id
                    })
                    this.callbacks.onSelectColorCb(id)
                }
            }).init(this.getEl())
        })
    }

    _updateCheckboxes() {
        this.params.colorItems.forEach((id) => {
            this.checkboxes[id].setState({
                checked: this.getState().selectedColorId === id
            })
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/SelectColorContent.js